import {atom} from "recoil";
import {
    AncillaryExceptionEntityResponse,
    AncillaryExceptionSelectFE,
    FormSearchAncillaryExceptionModel
} from "../api/types/ancillaryException";

export const ancillaryExceptionSelectAtom = atom<AncillaryExceptionSelectFE[]>({
    key: "ancillaryExceptionSelectAtom",
    default: []
});

export const initialAncillaryExceptionFilters: FormSearchAncillaryExceptionModel = {
    commercialCategoryId: null,
    commercialSegmentId: null,
    name: "",
    productCode: "",
    ancillaryId: null,
    reservationFrom: null,
    reservationTo: null,
    pickupDateFrom: null,
    pickupDateTo: null,
    dealers: [],
    legalEntities: []

};
export const ancillaryExceptionFiltersAtom = atom<FormSearchAncillaryExceptionModel>({
    key: "ancillaryExceptionFiltersAtom",
    default: initialAncillaryExceptionFilters
});

export const ancillaryExceptionAtom = atom<AncillaryExceptionEntityResponse | null>({
    key: "ancillaryExceptionAtom",
    default: null
});